import { actions } from "../../actions/action-list";
import initialState from "./initialState";

const Expenses = (state = initialState, action = {}) => {
  switch (action.type) {
    case actions.FETCH_ALL_OPERATOR_EXPENSES:
      return { ...state, allOperatorsExpenses: action.value };
    case actions.CREATE_OPERATOR_EXPENSES:
      return { ...state, createOperatorExpenseResponse: action.value };
    case actions.FETCH_OPERATOR_EXPENSE_LIST:
      return { ...state, operatorExpenseList: action.value };
    case actions.CLEAR_OPERATOR_EXPENSE_LIST:
      return { ...state, operatorExpenseList: action.value };
    case actions.EXPENSE_UPLOAD_FAILURE:
      return { ...state, expenseUploadSheetError: action.value };
    default:
      return state;
  }
};

export default Expenses;
